import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Preset_fabric from "./preset_fabric_select";
import { db } from "../firebase";
import { getData, handleFireBaseUpload } from "../Firebase/firestore";

import { StylesFilter, StylesFilter_Blazer, StylesFilter_formal, StylesFilter_kurta } from '../Data';
import StyleModal from "./stylemodal";
import SeoPanel from "./SeoPanel";
import DiscoveryPanel from "./DiscoveryPanel";
import {
    slugify,
    generateSku,
    autoKeywords,
    autoCanonicalUrl,
    autoAltText,
} from '../Funtions/seo';
import {
    PRODUCT_KINDS,
    GARMENT_CATEGORIES,
    CUSTOMIZER_CATEGORIES,
    ACCESSORY_TYPES,
    ACCESSORY_CATEGORY,
    PIECE_POSITIONS,
    PAIRING_HINTS,
    getCategory,
    categoryFromCustomizerRoute,
    inferProductKind,
    getKindLabel,
} from '../Data/catalog';
import {
    DEPARTMENTS,
    homeOf,
    styleTagOptionsFor,
    sizingOf,
    categoriesOfDepartment,
    pathOfStyle,
} from '../Data/taxonomy';
import {
    buildPieces,
    buildFabricIds,
    computeFinalPrice,
    customizerOffer,
    deriveColorFamilies,
    suggestTags,
    occasionLabels,
    keysFromLabels,
    publishChecklist,
    productTypeLabel,
} from '../Funtions/productDerive';
import sh from '../assets/search.png';


import './main.css';
import './resources.css';
import './discovery_panel.css';

const types = CUSTOMIZER_CATEGORIES.map((c) => c.value);

const pickFilter = (type) => {
    if (type === 'suit' || type === 'vestcoat') return StylesFilter;
    if (type === 'formal' || type === 'pant' || type === 'shirt') return StylesFilter_formal;
    if (type === 'kurta' || type === 'sadri' || type === 'only_kurta' || type === 'pajama') return StylesFilter_kurta;
    if (type === 'blazer') return StylesFilter_Blazer;
    return StylesFilter;
};

const piecesFor = (category) => (getCategory(category)?.pieces || []);

// Suggestions only: the box still takes any text.
const CARE_OPTIONS = [
    'Dry clean only',
    'Machine wash cold',
    'Gentle machine wash',
    'Hand wash cold',
    'Dry clean recommended',
    'Spot clean only',
];

const defaultSelectionsFor = (category) => {
    const out = {};
    (getCategory(category)?.defaultPieces || []).forEach((p) => { out[p] = null; });
    return out;
};

const listOf = (v) => (Array.isArray(v) ? v.filter(Boolean) : []);

// Firestore rejects undefined values anywhere in a document.
const firestoreSafe = (v) => {
    if (Array.isArray(v)) return v.filter((x) => x !== undefined).map(firestoreSafe);
    if (v && typeof v === 'object' && Object.getPrototypeOf(v) === Object.prototype) {
        const out = {};
        Object.keys(v).forEach((k) => {
            if (v[k] !== undefined) out[k] = firestoreSafe(v[k]);
        });
        return out;
    }
    return v;
};

// Supplementary style code labels for values that aren't in admin's StylesFilter
// (used only for the URL-import preview panel).
// Shape: EXTRA_STYLE_LABELS[garment][pos][n][value] = { type, name }
const EXTRA_STYLE_LABELS = {
    Coat: {
        F: {
            0: {
                '1B': { type: 'Single Brested', name: 'Single Button' },
                '2B': { type: 'Single Brested', name: 'Double Button' },
                '3B': { type: 'Single Brested', name: 'Three Button' },
                '4B': { type: 'Double Brested', name: 'Four Button' },
                '6B': { type: 'Double Brested', name: 'Six Button' },
                'JH': { type: 'Jodhpuri', name: 'Semi Round' },
                'JR': { type: 'Jodhpuri', name: 'Round' },
                'JS': { type: 'Jodhpuri', name: 'Straight' },
                'JC': { type: 'Jodhpuri', name: 'Open Coat' },
                'JA': { type: 'Jodhpuri', name: 'Open Jodhpuri' },
            },
            1: {
                'N': { type: 'Lapel', name: 'Notch' },
                'P': { type: 'Lapel', name: 'Peak' },
                'S': { type: 'Lapel', name: 'Saul' },
            },
            2: {
                'F': { type: 'Bottom Pocket', name: 'Flap' },
                'FL': { type: 'Bottom Pocket', name: 'Flap' },
                'P': { type: 'Bottom Pocket', name: 'Patch' },
                'PT': { type: 'Bottom Pocket', name: 'Patch' },
            },
            3: {
                'W': { type: 'Upper Pocket', name: 'Wallet' },
                'P': { type: 'Upper Pocket', name: 'Patch' },
            },
            4: {
                'N': { type: 'Stitch', name: 'No Stitch' },
                'Y': { type: 'Stitch', name: 'Stitch' },
                '': { type: 'Stitch', name: 'No Stitch' },
            },
        },
        B: {
            0: {
                'NV': { type: 'Back Style', name: 'Non Vent' },
                'SV': { type: 'Back Style', name: 'Single Vent' },
                'DV': { type: 'Back Style', name: 'Side Vent' },
                '1V': { type: 'Back Style', name: 'Single Vent' },
                '2V': { type: 'Back Style', name: 'Side Vent' },
            },
        },
    },
    Pant: {
        F: {
            0: {
                'F-NP': { type: 'Style', name: 'Non Plates' },
                'F-SP': { type: 'Style', name: 'Single Plates' },
                'F-DP': { type: 'Style', name: 'Double Plates' },
            },
            1: {
                'C': { type: 'Crease', name: 'Crease' },
                'NC': { type: 'Crease', name: 'No Crease' },
            },
            2: {
                'H': { type: 'Hem', name: 'Turn Up' },
                'NH': { type: 'Hem', name: 'Plain' },
            },
        },
        B: {
            0: {
                'B-SP': { type: 'Back Pocket', name: 'Single Pocket' },
                'B-DP': { type: 'Back Pocket', name: 'Double Pocket' },
                'B-NP': { type: 'Back Pocket', name: 'No Pocket' },
            },
        },
    },
    Vest: {
        F: {
            0: {
                'SB': { type: 'Style', name: 'Single Brested' },
                'DB': { type: 'Style', name: 'Double Brested' },
            },
        },
    },
};

function Presets_upload() {
    const location = useLocation();
    const navigate = useNavigate();
    const editLoadRef = useRef(null);
    const editBaselineRef = useRef(null);

    const [editingDocId, setEditingDocId] = useState(null);
    const [keptImages, setKeptImages] = useState(null);
    const [hydrating, setHydrating] = useState(false);

    const [imgs, setImgs] = useState([]);
    const [preview, setPreview] = useState([]);
    const [dragIdx, setDragIdx] = useState(null);
    const [dragOverIdx, setDragOverIdx] = useState(null);

    const [styleTypes, setStyleTypes] = useState("suit");

    const [useFilter, setUseFilter] = useState(pickFilter('suit'));

    const [defaultStyle] = useState({
        "Coat": { "F": ["2B", "N", "FL", ""], "B": ["NV"] },
        "Pant": { "F": ["F-NP", "C", "H"], "B": ["B-SP"] },
        "Vest": { "F": ["SB"] },
        "Shirt": { "F": ["BASE", "P1", "SS", "SLEVE", "N"] },
        "Kurta": { "F": ["S", "NS", "00", "R", "0", "R", "0", "CM", "SN", "US1"] },
        "Pajama": { "F": ["PJ", "E"] },
        "Sadri": { "F": ["EE", "1"] },
    });

    useEffect(() => {
        if (hydrating) return;
        if (editingDocId) return;
        if (importedStyleRef.current) return;
        if (styleTypes) {
            const ts = piecesFor(styleTypes).filter((t) => defaultStyle[t]);
            const fin = { style: {}, types: ts };
            ts.forEach((e) => { fin.style[e] = defaultStyle[e]; });
            setSel(fin);
        }
    }, [styleTypes, defaultStyle, hydrating, editingDocId]);

    useEffect(() => {
        const p = location.state && location.state.editPreset;
        if (!p || !p.doc) return;
        if (editLoadRef.current === p.doc) return;
        editLoadRef.current = p.doc;
        editBaselineRef.current = JSON.parse(JSON.stringify(p));

        setHydrating(true);
        setEditingDocId(p.doc);
        const kind = inferProductKind(p);
        setProductKind(kind);
        const cat = kind === 'accessory' ? ACCESSORY_CATEGORY : (p.category || "suit");
        setStyleTypes(cat);
        setUseFilter(pickFilter(cat));
        setAccessoryType(p.accessoryType || '');
        setStyleTags(Array.isArray(p.styleTags) ? p.styleTags : []);
        setStock(p.stock != null ? String(p.stock) : '');
        setSampleSize(p.sampleSize || '');
        setDeliveryDays(p.deliveryDays != null ? String(p.deliveryDays) : '');
        setPairsWith(listOf(p.pairsWith));
        setSuitsCategories(listOf(p.suitsCategories));

        const legacy = keysFromLabels(Array.isArray(p.ocassion) && p.ocassion.length ? p.ocassion : String(p.occasion || '').split(/[\n,]/));
        setOccasions(listOf(p.occasions).length ? listOf(p.occasions) : legacy.occasions);
        setFestivals(listOf(p.festivals).length ? listOf(p.festivals) : legacy.festivals);
        setLegacyOccasionLabels(legacy.unmatched);
        setRoles(listOf(p.roles));
        setVibe(listOf(p.vibe || p.vibes));
        setFormality(Number(p.formality) || 0);
        if (listOf(p.colorFamilies).length) {
            setColorFamiliesManual(listOf(p.colorFamilies));
            setColorAuto(false);
        } else {
            setColorFamiliesManual([]);
            setColorAuto(true);
        }
        setImportUrl(p.customize_url || "");
        setKeptImages({ src: p.src || "", single: Array.isArray(p.single) ? p.single : [] });
        setImgs([]);
        setErr(false);

        // Hydrate SEO fields
        setSeoSlug(p.slug || '');
        setSlugTouched(!!p.slug);
        setSeoSku(p.sku || '');
        setSeoSubCategory(p.subCategory || '');
        setSeoMetaTitle(p.metaTitle || '');
        setSeoMetaDescription(p.metaDescription || '');
        setSeoKeywords(Array.isArray(p.keywords) ? p.keywords : []);
        setSeoCanonicalUrl(p.canonicalUrl || '');
        setSeoNoindex(!!p.noindex);
        setSeoOgImage(p.ogImage || '');
        setSeoLongDescription(p.longDescription || '');
        setSeoFaqs(Array.isArray(p.faqs) ? p.faqs : []);
        setSeoMaterial(p.material || '');
        setSeoPattern(p.pattern || '');
        setSeoColorName(p.colorName || '');
        setSeoColors(Array.isArray(p.color) ? p.color : []);
        setSeoGender(p.gender || 'male');
        setSeoAvailability(p.availability || 'MadeToOrder');
        // Products saved before `status` existed are already live on the storefront.
        setSeoStatus(p.status || 'published');
        setSeoRedirectSlugs(Array.isArray(p.redirectSlugs) ? p.redirectSlugs : []);
        setSeoVideoUrl(p.videoUrl || '');
        // Image alts: prefer images[].alt if present, else empty placeholders
        const existingImages = Array.isArray(p.images) ? p.images : [];
        const urlList = [p.src || '', ...(Array.isArray(p.single) ? p.single : [])].filter(Boolean);
        setImageAlts(urlList.map((u, i) => {
            const found = existingImages.find((im) => im && im.url === u);
            return found && found.alt ? found.alt : '';
        }));

        window.setTimeout(() => {
            if (name.current) name.current.value = p.name || "";
            if (des.current) des.current.value = p.des || "";
            if (price.current) price.current.value = p.price != null && p.price !== "" ? String(p.price) : "";
            if (discount.current) discount.current.value = p.discount != null && p.discount !== "" ? String(p.discount) : "";
            if (washcare.current) washcare.current.value = p.washcare || "";
            {
                // Older multi-piece products have one line for the whole look;
                // start every piece from it so editing does not blank it.
                const loadedPieces = [...new Set((Array.isArray(p.fabrics) ? p.fabrics : []).map((f) => f && f.type).filter(Boolean))];
                const saved = p.washcarePieces && typeof p.washcarePieces === 'object' ? p.washcarePieces : {};
                setCareByPiece(Object.keys(saved).length || loadedPieces.length < 2 || !p.washcare
                    ? saved
                    : Object.fromEntries(loadedPieces.map((t) => [t, p.washcare])));
            }
            if (size_fit.current) size_fit.current.value = p.size_fit || "";

            const fabrics = Array.isArray(p.fabrics) ? p.fabrics : [];
            if (kind === 'sample') {
                const selMap = {};
                fabrics.forEach((row) => {
                    const t = row.type;
                    if (t) selMap[t] = row.fabric && typeof row.fabric === 'object' ? row.fabric : row;
                });
                setPresetSelections(selMap);
                const known = piecesFor(cat);
                setCustomItems(Object.keys(selMap).filter((k) => !known.includes(k)));
            } else {
                setPresetSelections({});
                setCustomItems([]);
            }
            if (kind === 'customizer') {
                setFabricsIn(fabrics);
            }
            if (p.types && p.style && typeof p.style === "object") {
                setSel({ style: JSON.parse(JSON.stringify(p.style)), types: [...p.types] });
            } else {
                const ts = piecesFor(cat).filter((t) => defaultStyle[t]);
                const fin = { style: {}, types: ts };
                ts.forEach((e) => {
                    fin.style[e] = defaultStyle[e] ? JSON.parse(JSON.stringify(defaultStyle[e])) : {};
                });
                setSel(fin);
            }
            setHydrating(false);
            bumpForm();
        }, 80);

        navigate(location.pathname, { replace: true, state: {} });
    }, [location, navigate]);

    const name = useRef();
    const price = useRef();
    const discount = useRef();
    const des = useRef();
    const size_fit = useRef();
    const washcare = useRef();
    // Care per piece for a multi-piece look: a cotton kurta and pajama wash at
    // home while a velvet sadri needs dry cleaning, which one box cannot say.
    const [careByPiece, setCareByPiece] = useState({});

    const [Err, setErr] = useState();
    const [productKind, setProductKind] = useState('sample');
    const customize = productKind === 'customizer';
    const isAccessory = productKind === 'accessory';
    const [accessoryType, setAccessoryType] = useState('');
    // Filter-level styles (achkan, dhoti…) from the shared taxonomy.
    const [styleTags, setStyleTags] = useState([]);
    const [stock, setStock] = useState('');
    const [sampleSize, setSampleSize] = useState('');
    const [deliveryDays, setDeliveryDays] = useState('');
    const [pairsWith, setPairsWith] = useState([]);
    const [suitsCategories, setSuitsCategories] = useState([]);
    const [occasions, setOccasions] = useState([]);
    const [festivals, setFestivals] = useState([]);
    const [legacyOccasionLabels, setLegacyOccasionLabels] = useState([]);
    const [roles, setRoles] = useState([]);
    const [vibe, setVibe] = useState([]);
    const [formality, setFormality] = useState(0);
    const [colorAuto, setColorAuto] = useState(true);
    const [colorFamiliesManual, setColorFamiliesManual] = useState([]);
    const [suggestNote, setSuggestNote] = useState('');
    const [accessoryProducts, setAccessoryProducts] = useState([]);
    const [publishAttempted, setPublishAttempted] = useState(false);
    const [, setFormNonce] = useState(0);
    const bumpForm = () => setFormNonce((n) => n + 1);

    const [load, setLoad] = useState(false);
    const [uploadStatus, setUploadStatus] = useState('');
    const [successModal, setSuccessModal] = useState(null);

    const [fabrics, setFabrics] = useState([]);
    const [fabricsIn, setFabricsIn] = useState([]);
    const [sel, setSel] = useState();
    const [stylemodal, setStyleModal] = useState(false);

    const [presetSelections, setPresetSelections] = useState(() => defaultSelectionsFor('suit'));
    const [pickerModal, setPickerModal] = useState({ open: false, item: null });
    const [pickerSearch, setPickerSearch] = useState('');
    const [pickerBrandFilter, setPickerBrandFilter] = useState('');
    const [pickerTypeFilter, setPickerTypeFilter] = useState('');
    const [pickerBrandOpen, setPickerBrandOpen] = useState(false);
    const [pickerTypeOpen, setPickerTypeOpen] = useState(false);
    const pickerBrandRef = useRef(null);
    const pickerTypeRef = useRef(null);
    const [customItems, setCustomItems] = useState([]);
    const [addItemModal, setAddItemModal] = useState({ open: false, value: '' });

    const [importUrl, setImportUrl] = useState('');
    const [importLoading, setImportLoading] = useState(false);
    const [importStatus, setImportStatus] = useState(null);
    const [importedData, setImportedData] = useState(null);
    // Set once a customizer link's style is applied. Importing also switches
    // the category, and the category effect would then overwrite that style
    // with the category defaults (salwar became plain pajama, cuffs dropped).
    const importedStyleRef = useRef(false);
    const [importDebugOpen, setImportDebugOpen] = useState(false);
    const [previewTab, setPreviewTab] = useState('');

    // ─── SEO fields (per admin-panel-seo-spec.md) ──────────────────────────────
    const [seoSlug, setSeoSlug] = useState('');
    const [slugTouched, setSlugTouched] = useState(false);
    const [seoSku, setSeoSku] = useState('');
    const [seoSubCategory, setSeoSubCategory] = useState('');
    const [seoMetaTitle, setSeoMetaTitle] = useState('');
    const [seoMetaDescription, setSeoMetaDescription] = useState('');
    const [seoKeywords, setSeoKeywords] = useState([]);
    const [seoCanonicalUrl, setSeoCanonicalUrl] = useState('');
    const [seoNoindex, setSeoNoindex] = useState(false);
    const [seoOgImage, setSeoOgImage] = useState('');
    const [seoLongDescription, setSeoLongDescription] = useState('');
    const [seoFaqs, setSeoFaqs] = useState([]);
    const [seoMaterial, setSeoMaterial] = useState('');
    const [seoPattern, setSeoPattern] = useState('');
    const [seoColorName, setSeoColorName] = useState('');
    const [seoColors, setSeoColors] = useState([]);
    const [seoGender, setSeoGender] = useState('male');
    const [seoAvailability, setSeoAvailability] = useState('MadeToOrder');
    const [seoStatus, setSeoStatus] = useState('published');
    const [seoRedirectSlugs, setSeoRedirectSlugs] = useState([]);
    const [seoVideoUrl, setSeoVideoUrl] = useState('');
    const [imageAlts, setImageAlts] = useState([]); // parallel to preview[]
    const [seoOpen, setSeoOpen] = useState(true);

    const setSlugManual = (v) => {
        setSlugTouched(true);
        setSeoSlug(v);
    };

    useEffect(() => {
        const onClick = (e) => {
            if (pickerBrandRef.current && !pickerBrandRef.current.contains(e.target)) setPickerBrandOpen(false);
            if (pickerTypeRef.current && !pickerTypeRef.current.contains(e.target)) setPickerTypeOpen(false);
        };
        document.addEventListener('mousedown', onClick);
        return () => document.removeEventListener('mousedown', onClick);
    }, []);

    const presetItems = [...piecesFor(styleTypes), ...customItems.filter((c) => !piecesFor(styleTypes).includes(c))];

    const currentName = () => (name.current ? name.current.value : '');
    const currentDes = () => (des.current ? des.current.value : '');

    const derivedColorFamilies = deriveColorFamilies({
        name: currentName(),
        colorName: seoColorName,
        swatches: seoColors,
        fabrics: fabricsIn,
    });
    const colorFamilies = colorAuto ? derivedColorFamilies : colorFamiliesManual;
    const setColorFamilies = (next) => {
        setColorAuto(false);
        setColorFamiliesManual(next);
    };
    const resetColorFamilies = () => {
        setColorAuto(true);
        setColorFamiliesManual([]);
    };

    const pairOptions = (() => {
        const hints = PAIRING_HINTS[styleTypes] || [];
        return accessoryProducts
            .filter((a) => a.id !== editingDocId)
            .map((a) => ({ ...a, recommended: hints.includes(a.accessoryType) || listOf(a.suitsCategories).includes(styleTypes) }))
            .sort((a, b) => Number(b.recommended) - Number(a.recommended));
    })();

    const applySuggestedTags = () => {
        const s = suggestTags({
            kind: productKind,
            category: styleTypes,
            accessoryType,
            name: currentName(),
            des: currentDes(),
            subCategory: seoSubCategory,
            colorName: seoColorName,
            swatches: seoColors,
            fabrics: fabricsIn,
        });
        const filled = [];
        if (!occasions.length && s.occasions.length) { setOccasions(s.occasions); filled.push('occasions'); }
        if (!festivals.length && s.festivals.length) { setFestivals(s.festivals); filled.push('festivals'); }
        if (!roles.length && s.roles.length && !isAccessory) { setRoles(s.roles); filled.push('who it is for'); }
        if (!vibe.length && s.vibe.length) { setVibe(s.vibe); filled.push('vibe'); }
        if (!formality) { setFormality(s.formality); filled.push('formality'); }
        if (isAccessory && !suitsCategories.length) {
            const goesWith = Object.keys(PAIRING_HINTS).filter((cat) => PAIRING_HINTS[cat].includes(accessoryType));
            if (goesWith.length) { setSuitsCategories(goesWith); filled.push('goes with'); }
        }
        setSuggestNote(filled.length
            ? `Filled ${filled.join(', ')}. Untick anything that does not fit this product.`
            : 'Every group already has a selection — nothing was changed.');
    };

    const chooseCategory = (value) => {
        if (value === styleTypes) return;
        setStyleTypes(value);
        setUseFilter(pickFilter(value));
        if (productKind === 'sample' && !editingDocId) {
            setPresetSelections(defaultSelectionsFor(value));
            setCustomItems([]);
        }
    };

    const addCustomItem = (raw) => {
        const name = (raw || '').trim();
        if (!name) return false;
        const normalized = name
            .split(' ')
            .map((w) => (w ? w.charAt(0).toUpperCase() + w.slice(1).toLowerCase() : w))
            .join(' ');
        const exists = presetItems.some((i) => i.toLowerCase() === normalized.toLowerCase());
        if (exists) return false;
        setCustomItems((prev) => [...prev, normalized]);
        setPresetSelections((prev) => ({ ...prev, [normalized]: null }));
        return true;
    };

    useEffect(() => {
        if (productKind === 'sample') {
            const arr = Object.entries(presetSelections)
                .filter(([, f]) => f !== null && f !== undefined)
                .map(([t, f]) => ({ ...f, type: t }));
            setFabricsIn(arr);
        }
    }, [presetSelections, productKind]);

    const toggleItemTick = (item) => {
        setPresetSelections((prev) => {
            if (item in prev) {
                const next = { ...prev };
                delete next[item];
                return next;
            }
            return { ...prev, [item]: null };
        });
    };

    const openFabricPickerFor = (item) => {
        setPickerSearch('');
        setPickerBrandFilter('');
        setPickerTypeFilter('');
        setPickerBrandOpen(false);
        setPickerTypeOpen(false);
        setPickerModal({ open: true, item });
    };

    const closeFabricPicker = () => setPickerModal({ open: false, item: null });

    const pickFabricForItem = (fabric) => {
        if (!pickerModal.item) return;
        setPresetSelections((prev) => ({ ...prev, [pickerModal.item]: fabric }));
        closeFabricPicker();
    };

    const clearFabricForItem = (item) => {
        setPresetSelections((prev) => ({ ...prev, [item]: null }));
    };

    const switchKind = (kind) => {
        if (kind === productKind) return;
        setProductKind(kind);
        setFabricsIn([]);
        setCustomItems([]);
        setImportedData(null); importedStyleRef.current = false;
        setImportStatus(null);
        setOccasions([]);
        setFestivals([]);
        setRoles([]);
        setVibe([]);
        setFormality(0);
        setPairsWith([]);
        setSuitsCategories([]);
        setSuggestNote('');
        if (kind === 'accessory') {
            setStyleTypes(ACCESSORY_CATEGORY);
            setPresetSelections({});
            setSeoAvailability('InStock');
            return;
        }
        let cat = styleTypes === ACCESSORY_CATEGORY ? 'suit' : styleTypes;
        if (kind === 'customizer' && !getCategory(cat)?.customizer) cat = 'suit';
        setStyleTypes(cat);
        setUseFilter(pickFilter(cat));
        setPresetSelections(kind === 'sample' ? defaultSelectionsFor(cat) : {});
        if (seoAvailability === 'InStock') setSeoAvailability('MadeToOrder');
    };

    const pickerBrandsList = Array.from(new Set((fabrics || []).map((f) => f.brand).filter(Boolean)));
    const pickerTypesList = Array.from(new Set((fabrics || []).map((f) => f.fabricType).filter(Boolean)));
    const filteredFabricsForPicker = (() => {
        const q = (pickerSearch || '').toLowerCase().trim();
        return (fabrics || []).filter((f) => {
            if (pickerBrandFilter && String(f.brand || '').toLowerCase() !== pickerBrandFilter.toLowerCase()) return false;
            if (pickerTypeFilter && String(f.fabricType || '').toLowerCase() !== pickerTypeFilter.toLowerCase()) return false;
            if (q) {
                const hay = `${f.name || ''} ${f.brand || ''} ${f.color || ''} ${f.pattern || ''} ${f.fabricType || ''}`.toLowerCase();
                if (!hay.includes(q)) return false;
            }
            return true;
        });
    })();

    // Fabric upload writes every fabric to Fabric/Suits/fabrics; older per-category docs are merged in.
    const fabricGroup = getCategory(styleTypes)?.fabricGroup || 'Suits';
    useEffect(() => {
        if (isAccessory) return;
        let cancelled = false;
        const groups = Array.from(new Set(['Suits', fabricGroup]));
        Promise.all(groups.map((g) => getData(db.collection('Fabric').doc(g).collection('fabrics')).catch(() => [])))
            .then((lists) => {
                if (cancelled) return;
                const seen = new Set();
                const merged = [];
                lists.flat().forEach((f) => {
                    const key = String((f && (f.id || f.doc)) || '');
                    if (!f || (key && seen.has(key))) return;
                    if (key) seen.add(key);
                    merged.push(f);
                });
                setFabrics(merged);
            });
        return () => { cancelled = true; };
    }, [fabricGroup, isAccessory]);

    useEffect(() => {
        getData(db.collection('Presets')).then((rows) => {
            setAccessoryProducts((rows || [])
                .filter((r) => inferProductKind(r) === 'accessory' && r.status !== 'archived')
                .map((r) => ({ id: r.doc, name: r.name, src: r.src, accessoryType: r.accessoryType, suitsCategories: r.suitsCategories })));
        }).catch(() => setAccessoryProducts([]));
    }, []);

    useEffect(() => {
        if (imgs && imgs.length > 0) {
            const data = imgs.map((f) => URL.createObjectURL(f));
            setPreview(data);
        } else if (keptImages && keptImages.src) {
            setPreview([keptImages.src, ...(keptImages.single || [])].filter(Boolean));
        } else {
            setPreview([]);
        }
    }, [imgs, keptImages]);

    // Keep imageAlts array length in sync with preview length
    useEffect(() => {
        setImageAlts((prev) => {
            const next = [...prev];
            if (next.length < preview.length) {
                while (next.length < preview.length) next.push('');
            } else if (next.length > preview.length) {
                next.length = preview.length;
            }
            return next;
        });
    }, [preview.length]);

    const handleImgsChange = (e) => {
        const arr = Array.from(e.target.files || []);
        setImgs(arr);
        setDragIdx(null);
        setDragOverIdx(null);
    };

    const handleDragStart = (i, e) => {
        setDragIdx(i);
        if (e && e.dataTransfer) {
            e.dataTransfer.effectAllowed = 'move';
            try { e.dataTransfer.setData('text/plain', String(i)); } catch (_) {}
        }
    };

    const handleDragOver = (i, e) => {
        if (e) e.preventDefault();
        if (dragIdx !== null && dragOverIdx !== i) setDragOverIdx(i);
    };

    const handleDragLeave = (i) => {
        if (dragOverIdx === i) setDragOverIdx(null);
    };

    const handleDrop = (i, e) => {
        if (e) e.preventDefault();
        if (dragIdx === null || dragIdx === i) {
            setDragIdx(null);
            setDragOverIdx(null);
            return;
        }
        if (imgs.length > 0) {
            const next = [...imgs];
            const [moved] = next.splice(dragIdx, 1);
            next.splice(i, 0, moved);
            setImgs(next);
        } else if (keptImages && keptImages.src) {
            const urls = [keptImages.src, ...(Array.isArray(keptImages.single) ? keptImages.single : [])].filter(Boolean);
            const [moved] = urls.splice(dragIdx, 1);
            urls.splice(i, 0, moved);
            const [first, ...rest] = urls;
            setKeptImages({ src: first || "", single: rest });
        }
        // Move alt text in lockstep with image reorder
        setImageAlts((prev) => {
            const next = [...prev];
            if (dragIdx >= next.length) return next;
            const [moved] = next.splice(dragIdx, 1);
            next.splice(i, 0, moved);
            return next;
        });
        setDragIdx(null);
        setDragOverIdx(null);
    };

    const handleDragEnd = () => {
        setDragIdx(null);
        setDragOverIdx(null);
    };

    const removeImageAt = (i) => {
        if (imgs.length > 0) {
            const next = [...imgs];
            next.splice(i, 1);
            setImgs(next);
        } else if (keptImages && keptImages.src) {
            const urls = [keptImages.src, ...(Array.isArray(keptImages.single) ? keptImages.single : [])].filter(Boolean);
            urls.splice(i, 1);
            if (urls.length === 0) {
                setKeptImages(null);
            } else {
                const [first, ...rest] = urls;
                setKeptImages({ src: first || "", single: rest });
            }
        }
        setImageAlts((prev) => prev.filter((_, idx) => idx !== i));
        setDragIdx(null);
        setDragOverIdx(null);
    };

    const updateImageAlt = (i, val) => {
        setImageAlts((prev) => {
            const next = [...prev];
            next[i] = val;
            return next;
        });
    };

    const [priceFinal, setPrice] = useState(0);

    const computePrice = () => {
        let p = 0;
        if (fabricsIn) fabricsIn.forEach((val) => { p += parseInt(val.price) || 0; });
        return p;
    };

    useEffect(() => { setPrice(computePrice()); }, [fabricsIn]);
    const offer = customizerOffer(fabricsIn);

    const carePieces = isAccessory ? [] : [...new Set((fabricsIn || []).map((f) => f && f.type).filter(Boolean))];
    const perPieceCare = carePieces.length > 1;
    // washcare stays a plain string for everything that already reads it;
    // with several pieces it carries a one-line summary of washcarePieces.
    const carePayload = () => {
        if (!perPieceCare) {
            return { washcare: washcare.current ? washcare.current.value.trim() : '', washcarePieces: {} };
        }
        const pieces = {};
        carePieces.forEach((t) => {
            const v = String(careByPiece[t] || '').trim();
            if (v) pieces[t] = v;
        });
        const values = [...new Set(Object.values(pieces))];
        const summary = values.length === 1 && Object.keys(pieces).length === carePieces.length
            ? values[0]
            : Object.entries(pieces).map(([t, v]) => `${t}: ${v}`).join(' · ');
        return { washcare: summary, washcarePieces: pieces };
    };

    const resetForm = () => {
        setStyleTags([]);
        if (name.current) name.current.value = '';
        if (price.current) price.current.value = '';
        if (discount.current) discount.current.value = '';
        if (des.current) des.current.value = '';
        if (washcare.current) washcare.current.value = '';
        setCareByPiece({});
        if (size_fit.current) size_fit.current.value = '';
        setImgs([]);
        setPreview([]);
        setDragIdx(null);
        setDragOverIdx(null);
        setFabricsIn([]);
        setPresetSelections(productKind === 'sample' ? defaultSelectionsFor(styleTypes) : {});
        setCustomItems([]);
        setImportUrl('');
        setImportStatus(null);
        setImportedData(null); importedStyleRef.current = false;
        setStock('');
        setSampleSize('');
        setDeliveryDays('');
        setPairsWith([]);
        setSuitsCategories([]);
        setOccasions([]);
        setFestivals([]);
        setLegacyOccasionLabels([]);
        setRoles([]);
        setVibe([]);
        setFormality(0);
        setColorAuto(true);
        setColorFamiliesManual([]);
        setSuggestNote('');
        setPublishAttempted(false);
        setErr(false);
        setEditingDocId(null);
        setKeptImages(null);
        setHydrating(false);
        editLoadRef.current = null;
        editBaselineRef.current = null;

        // Reset SEO state
        setSeoSlug('');
        setSlugTouched(false);
        setSeoSku('');
        setSeoSubCategory('');
        setSeoMetaTitle('');
        setSeoMetaDescription('');
        setSeoKeywords([]);
        setSeoCanonicalUrl('');
        setSeoNoindex(false);
        setSeoOgImage('');
        setSeoLongDescription('');
        setSeoFaqs([]);
        setSeoMaterial('');
        setSeoPattern('');
        setSeoColorName('');
        setSeoColors([]);
        setSeoGender('male');
        setSeoAvailability(productKind === 'accessory' ? 'InStock' : 'MadeToOrder');
        setSeoStatus('published');
        setSeoRedirectSlugs([]);
        setSeoVideoUrl('');
        setImageAlts([]);
    };

    const VIEW_PRODUCT_ADMIN_INDEX = 8;

    const handleCancelEdit = () => {
        resetForm();
        navigate(`/admin/${VIEW_PRODUCT_ADMIN_INDEX}`, { replace: true });
    };

    const seoContext = () => ({
        name: currentName(),
        des: currentDes(),
        kind: productKind,
        category: styleTypes,
        accessoryType,
        material: seoMaterial,
        pattern: seoPattern,
        colorName: seoColorName,
        occasions,
        festivals,
        roles,
        vibe,
        colorFamilies,
    });

    /**
     * SEO fields merged into every save. Every field is optional; blanks fall
     * back to values generated from the product's name, category and tags.
     */
    const buildSeoPayload = ({ docId, primaryImageUrl, allImageUrls }) => {
        const productName = currentName();
        const ctx = seoContext();

        const finalSlug = (seoSlug && seoSlug.trim()) || slugify(productName);
        const finalSku = (seoSku && seoSku.trim()) || generateSku(isAccessory ? accessoryType : styleTypes);
        // Blank title and description are saved blank: the website then builds
        // them from the product with its current keyword rules (the SEO panel
        // previews the same text). Only words someone typed are stored.
        const finalMetaTitle = (seoMetaTitle && seoMetaTitle.trim()) || '';
        const finalMetaDesc = (seoMetaDescription && seoMetaDescription.trim()) || '';
        const finalKeywords = seoKeywords.length ? seoKeywords : autoKeywords(ctx);
        const finalCanonical = (seoCanonicalUrl && seoCanonicalUrl.trim())
            || autoCanonicalUrl({ category: isAccessory ? ACCESSORY_CATEGORY : styleTypes, slug: finalSlug, docId });

        const images = (allImageUrls || []).map((url, i) => {
            const view = i === 0 ? 'front view' : `view ${i + 1}`;
            const explicitAlt = imageAlts[i] && imageAlts[i].trim();
            const fallbackAlt = autoAltText({ colorName: seoColorName, name: productName, view });
            return {
                url,
                alt: explicitAlt || fallbackAlt || `${productName || 'Product'} – ${view}`,
                isPrimary: i === 0 || undefined,
            };
        });

        const cleanFaqs = seoFaqs.filter((f) => f && (f.q || '').trim() && (f.a || '').trim());

        const payload = {
            slug: finalSlug,
            sku: finalSku,
            subCategory: seoSubCategory || '',
            metaTitle: finalMetaTitle,
            metaDescription: finalMetaDesc,
            keywords: finalKeywords,
            canonicalUrl: finalCanonical,
            noindex: !!seoNoindex,
            ogImage: (seoOgImage && seoOgImage.trim()) || primaryImageUrl || '',
            longDescription: seoLongDescription || '',
            faqs: cleanFaqs,
            material: seoMaterial || '',
            pattern: seoPattern || '',
            colorName: seoColorName || '',
            color: seoColors,
            gender: seoGender || 'male',
            availability: seoAvailability || 'MadeToOrder',
            currency: 'INR',
            status: seoStatus || 'published',
            redirectSlugs: seoRedirectSlugs,
            videoUrl: seoVideoUrl || '',
            images,
            updatedAt: new Date().toISOString(),
        };

        if (seoStatus === 'published') {
            payload.publishedAt = (editBaselineRef.current && editBaselineRef.current.publishedAt)
                || new Date().toISOString();
        }

        return payload;
    };

    const uploadImages = async (folder) => {
        let src0 = keptImages && keptImages.src ? keptImages.src : '';
        let singleArr = keptImages && Array.isArray(keptImages.single) ? [...keptImages.single] : [];
        if (imgs.length > 0) {
            const uploaded = [];
            for (let i = 0; i < imgs.length; i++) {
                uploaded.push(await handleFireBaseUpload(`${imgs[i].name}-${Date.now()}`, imgs[i], folder));
            }
            src0 = uploaded[0];
            singleArr = uploaded.slice(1);
        }
        return { src0, singleArr };
    };

    // The customizer reads `fabric[type]` with its price position and brand logo.
    const buildCustomizerFabrics = async () => {
        const positions = PIECE_POSITIONS[styleTypes] || {};
        const fabricMap = {};
        const finalTypes = [];
        let brands = null;
        for (const row of fabricsIn) {
            if (!row || !row.type) continue;
            const f = { ...(row.fabric && typeof row.fabric === 'object' ? row.fabric : row) };
            f.pos = Number(positions[row.type] ?? 0);
            if (!f.brandImg && f.brand) {
                if (!brands) brands = await getData(db.collection('Brands')).catch(() => []);
                const b = (brands || []).find((o) => o.name === f.brand);
                if (b && b.src) f.brandImg = b.src;
            }
            fabricMap[row.type] = f;
            if (!finalTypes.includes(row.type)) finalTypes.push(row.type);
        }
        return { fabricMap, finalTypes };
    };

    const uploadPreset = async () => {
        try {
            setLoad(true);
            setUploadStatus('Uploading images...');

            const collection = db.collection('Presets');
            const docId = editingDocId || collection.doc().id;
            const folder = isAccessory ? 'presets/accessories' : customize ? 'presets/custom' : 'presets/normal';
            const { src0, singleArr } = await uploadImages(folder);

            const baseline = { ...(editBaselineRef.current || {}) };
            delete baseline.doc;
            // Ratings come only from verified orders, never from the admin form.
            delete baseline.ratingValue;
            delete baseline.reviewCount;
            delete baseline.reviews;

            let customizerFields = {};
            if (customize) {
                setUploadStatus('Fetching brand details...');
                const { fabricMap, finalTypes } = await buildCustomizerFabrics();
                customizerFields = {
                    fabric: fabricMap,
                    types: finalTypes,
                    customize_url: importUrl ? importUrl.trim() : '',
                };
                // The link decides the style; sel can hold category defaults.
                const linkData = importUrl ? await decodeCustomizerUrl(importUrl.trim()) : null;
                const linkStyle = linkData && (linkData.style || linkData.styles);
                if (linkStyle && typeof linkStyle === 'object') customizerFields.style = linkStyle;
                else if (sel && sel.style) customizerFields.style = sel.style;
                if (importedData && importedData.button) customizerFields.button = importedData.button;
            }

            setUploadStatus('Saving to database...');
            const category = isAccessory ? ACCESSORY_CATEGORY : styleTypes;
            const catDef = getCategory(category);
            const listPrice = customize ? offer.list : (Number(price.current && price.current.value) || 0);
            const discountPct = customize ? offer.percent : (Number(discount.current && discount.current.value) || 0);
            const pieces = isAccessory ? [] : buildPieces(fabricsIn);
            const labels = [...occasionLabels({ occasions, festivals }), ...legacyOccasionLabels];

            const Data = {
                ...baseline,
                ...buildSeoPayload({ docId, primaryImageUrl: src0, allImageUrls: [src0, ...singleArr].filter(Boolean) }),
                name: currentName().trim(),
                des: currentDes(),
                price: listPrice,
                discount: discountPct,
                priceFinal: customize ? offer.finalPrice : computeFinalPrice(listPrice, discountPct),
                src: src0,
                single: singleArr,
                category,
                productKind,
                customize,
                accessoryType: isAccessory ? accessoryType : '',
                styleTags: styleTags.filter((t) => styleTagChoices.some((o) => o.value === t)),
                department: placement ? placement.department.slug : '',
                style: placement ? placement.style.slug : '',
                sizing: placementSizing,
                fabrics: isAccessory ? [] : fabricsIn,
                pieces,
                fabricIds: buildFabricIds(pieces),
                occasions,
                festivals,
                roles,
                vibe,
                formality: formality || null,
                colorFamilies,
                ocassion: labels,
                occasion: labels.join(', '),
                measurementProfile: isAccessory ? 'none' : (catDef ? catDef.measurement : 2),
                deliveryDays: Number(deliveryDays) || (catDef ? catDef.deliveryDays : 3),
                sampleSize: productKind === 'sample' ? sampleSize.trim() : '',
                stock: isAccessory && stock !== '' ? Math.max(0, parseInt(stock, 10) || 0) : null,
                pairsWith: isAccessory ? [] : pairsWith,
                suitsCategories: isAccessory ? suitsCategories : [],
                ...carePayload(),
                size_fit: size_fit.current ? size_fit.current.value : '',
                item_type: 1,
                ...customizerFields,
            };

            if (!editingDocId) Data.created = new Date().toString();
            await collection.doc(docId).set(firestoreSafe(Data));

            setSuccessModal({
                edited: !!editingDocId,
                name: Data.name,
                category: productTypeLabel(productKind, category, accessoryType),
                kind: getKindLabel(productKind),
                price: Data.priceFinal,
                status: Data.status,
                thumb: src0 || null,
                count: isAccessory ? null : fabricsIn.length,
            });
            if (isAccessory) {
                setAccessoryProducts((prev) => [
                    ...prev.filter((a) => a.id !== docId),
                    { id: docId, name: Data.name, src: src0, accessoryType, suitsCategories },
                ]);
            }
            resetForm();
        } catch (e) {
            console.error('while uploading preset', e);
            alert(`Upload failed, nothing was saved.\n\n${e && e.message ? e.message : e}`);
        } finally {
            setLoad(false);
            setUploadStatus('');
        }
    };

    const base64UrlToBytes = (str) => {
        let b64 = String(str || '').replace(/-/g, '+').replace(/_/g, '/');
        while (b64.length % 4) b64 += '=';
        const bin = atob(b64);
        const out = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
        return out;
    };

    const inflateBytes = async (bytes) => {
        const attempts = [
            { fmt: 'deflate', slice: bytes },
            { fmt: 'gzip', slice: bytes },
            { fmt: 'deflate-raw', slice: bytes },
            { fmt: 'deflate-raw', slice: bytes.slice(2, bytes.length - 4) },
            { fmt: 'deflate-raw', slice: bytes.slice(2) },
        ];
        for (const a of attempts) {
            try {
                const ds = new DecompressionStream(a.fmt);
                const stream = new Blob([a.slice]).stream().pipeThrough(ds);
                return await new Response(stream).text();
            } catch (_) { /* try next */ }
        }
        throw new Error('Could not decompress payload');
    };

    const parseCustomUrl = (urlStr) => {
        const u = new URL(urlStr);
        const parts = u.pathname.split('/').filter(Boolean);
        const personalizeIdx = parts.indexOf('personalize');
        const payload = personalizeIdx >= 0 && parts.length > personalizeIdx + 1
            ? parts[personalizeIdx + 1]
            : parts[parts.length - 1];
        const category = parts[1] || null;
        return { category, payload };
    };

    const STRIP_KEYS = new Set([
        'firestore', '_delegate', '_userDataWriter', '_persistenceProvider',
        'INTERNAL', '_appCompat', '_key', 'converter', 'settings', 'databaseId',
        '_config', '_container', '_isDeleted', '_options', '_name',
        '_automaticDataCollectionEnabled', 'app',
    ]);
    const deepClean = (v) => {
        if (Array.isArray(v)) return v.map(deepClean);
        if (v && typeof v === 'object') {
            const out = {};
            for (const k of Object.keys(v)) {
                if (STRIP_KEYS.has(k)) continue;
                out[k] = deepClean(v[k]);
            }
            return out;
        }
        return v;
    };

    const urlToFile = async (url, fallbackName) => {
        const res = await fetch(url, { mode: 'cors' });
        const blob = await res.blob();
        const ext = (blob.type && blob.type.split('/')[1]) || 'jpg';
        const name = fallbackName || `imported-${Date.now()}.${ext}`;
        return new File([blob], name, { type: blob.type || 'image/jpeg' });
    };

    const pickStr = (obj, keys) => {
        for (const k of keys) {
            if (obj && obj[k] != null && obj[k] !== '') return obj[k];
        }
        return '';
    };

    // Resolve a friendly label + icon for a style code, using the category's style filter.
    const lookupStyleAttr = (garment, pos, n, value, filterDefs) => {
        if (Array.isArray(filterDefs)) {
            const defs = filterDefs.filter(
                (d) => d && d.name === garment && d.pos === pos && d.n === n
            );
            for (const def of defs) {
                if (!Array.isArray(def.attr)) continue;
                for (const row of def.attr) {
                    if (!Array.isArray(row)) continue;
                    const hit = row.find((a) => a && a.value === value);
                    if (hit) return { ...hit, type: def.type, sub: def.sub };
                }
            }
        }
        const extra = EXTRA_STYLE_LABELS?.[garment]?.[pos]?.[n]?.[value];
        if (extra) return { img: null, ...extra, value };
        return null;
    };

    const buildStylePreview = (garment, posMap, filterDefs) => {
        if (!posMap || typeof posMap !== 'object') return [];
        const out = [];
        Object.keys(posMap).forEach((pos) => {
            const arr = Array.isArray(posMap[pos]) ? posMap[pos] : [];
            arr.forEach((val, idx) => {
                const hasVal = val !== undefined && val !== null && val !== '';
                const found = hasVal ? lookupStyleAttr(garment, pos, idx, val, filterDefs) : null;
                if (found) {
                    out.push({
                        type: found.type,
                        sub: found.sub,
                        name: found.name,
                        img: found.img,
                        value: val,
                    });
                } else if (hasVal) {
                    out.push({
                        type: `${pos === 'B' ? 'Back ' : ''}Style ${idx + 1}`,
                        sub: null,
                        name: String(val),
                        img: null,
                        value: val,
                    });
                }
            });
        });
        return out;
    };

    const applyImportedData = async (data, category) => {
        try {
            const cat = categoryFromCustomizerRoute(category) || categoryFromCustomizerRoute(data.category);
            if (cat) {
                setStyleTypes(cat);
                setUseFilter(pickFilter(cat));
            }

            const fab = data.fabric || data.fabrics || {};
            let built = [];
            if (Array.isArray(fab)) {
                built = fab.map((f) => ({
                    type: f.type || '',
                    price: f.price || 0,
                    fabric: f,
                    ...f,
                }));
            } else if (fab && typeof fab === 'object') {
                built = Object.keys(fab).map((type) => {
                    const f = fab[type] || {};
                    return {
                        type,
                        name: f.fabric || f.name || '',
                        price: f.price || 0,
                        brand: f.brand || '',
                        brandImg: f.brandImg || '',
                        src: f.fabricImg || (Array.isArray(f.src) ? f.src[0] : f.src) || '',
                        fabricID: f.fabricID || '',
                        pos: f.pos,
                        fabric: f,
                    };
                });
                built.sort((a, b) => (a.pos || 99) - (b.pos || 99));
            }
            if (built.length > 0) setFabricsIn(built);

            const styleObj = data.style || data.styles;
            if (styleObj && typeof styleObj === 'object') {
                const types = Array.isArray(data.types) && data.types.length > 0
                    ? data.types
                    : Object.keys(styleObj);
                importedStyleRef.current = true;
                setSel((prev) => ({ ...(prev || {}), types, style: styleObj }));
                setPreviewTab(types[0] || '');
            } else if (built.length > 0) {
                setPreviewTab(built[0].type || '');
            }

            bumpForm();

            const total = built.reduce((s, b) => s + (parseInt(b.price) || 0), 0);
            setImportStatus({
                kind: cat ? 'success' : 'error',
                text: cat
                    ? `Imported ${built.length} item${built.length === 1 ? '' : 's'} as ${getCategory(cat).label} · Price ₹${total}. Now add name, description, tags and photos.`
                    : `Imported ${built.length} item${built.length === 1 ? '' : 's'}, but the link's category "${category || data.category || 'unknown'}" is not recognised. Choose the category above before saving.`,
            });
        } catch (e) {
            console.error('import apply error', e);
            setImportStatus({ kind: 'error', text: 'Partial import. Check preview below and fill missing fields.' });
        }
    };

    const decodeCustomizerUrl = async (u) => {
        try {
            const { payload } = parseCustomUrl(u);
            if (!payload) return null;
            return deepClean(JSON.parse(await inflateBytes(base64UrlToBytes(payload))));
        } catch (e) {
            return null;
        }
    };

    const fetchFromUrl = async () => {
        const u = importUrl.trim();
        if (!u) {
            setImportStatus({ kind: 'error', text: 'Paste a product URL first.' });
            return;
        }
        setImportLoading(true);
        setImportStatus({ kind: 'info', text: 'Decoding URL...' });
        setImportedData(null); importedStyleRef.current = false;
        try {
            const { category, payload } = parseCustomUrl(u);
            if (!payload) throw new Error('Could not find encoded payload in URL');
            const bytes = base64UrlToBytes(payload);
            const text = await inflateBytes(bytes);
            let data;
            try {
                data = JSON.parse(text);
            } catch (_) {
                throw new Error('Decoded payload is not valid JSON');
            }
            const cleaned = deepClean(data);
            setImportedData(cleaned);
            if (!customize) setProductKind('customizer');
            await applyImportedData(cleaned, category);
        } catch (e) {
            setImportStatus({ kind: 'error', text: e.message || 'Failed to import from URL' });
        } finally {
            setImportLoading(false);
        }
    };

    const imageCount = imgs.length > 0
        ? imgs.length
        : (keptImages && keptImages.src ? 1 + (Array.isArray(keptImages.single) ? keptImages.single.length : 0) : 0);
    const selectionKeys = Object.keys(presetSelections);
    // Where this product will be listed on the website, from the shared
    // taxonomy: department, style page and the sizing step it needs.
    const placementDoc = isAccessory
        ? { productKind: 'accessory', accessoryType, styleTags }
        : {
            category: styleTypes,
            styleTags,
            types: productKind === 'sample' ? selectionKeys : (sel && Array.isArray(sel.types) ? sel.types : []),
            fabrics: productKind === 'sample' ? [] : fabricsIn,
        };
    const placement = homeOf(placementDoc);
    // Picker groups follow the website's departments; anything the taxonomy
    // does not list yet stays reachable under "Other".
    const garmentGroups = (() => {
        const used = new Set();
        const groups = DEPARTMENTS.filter((d) => d.slug !== 'accessory').map((d) => {
            const cats = categoriesOfDepartment(d.slug).map(getCategory).filter(Boolean);
            cats.forEach((c) => used.add(c.value));
            return { label: d.label, categories: cats };
        }).filter((g) => g.categories.length);
        const rest = GARMENT_CATEGORIES.filter((c) => !used.has(c.value));
        if (rest.length) groups.push({ label: 'Other', categories: rest });
        return groups;
    })();
    const accessoryGroups = (() => {
        const dept = DEPARTMENTS.find((d) => d.slug === 'accessory');
        const label = (v) => (ACCESSORY_TYPES.find((a) => a.value === v) || { label: v }).label;
        const used = new Set();
        const groups = dept.styles.filter((st) => st.page).map((st) => {
            const types = [st, ...dept.styles.filter((x) => !x.page && x.parent === st.slug)]
                .flatMap((x) => (x.match && x.match.accessoryTypes) || [])
                .filter((v) => !used.has(v) && used.add(v))
                .map((v) => ({ value: v, label: label(v) }));
            return { label: st.label, types };
        }).filter((g) => g.types.length);
        const rest = ACCESSORY_TYPES.filter((a) => !used.has(a.value));
        if (rest.length) groups.push({ label: 'Other', types: rest });
        return groups;
    })();
    const styleTagChoices = styleTagOptionsFor(placementDoc);
    const placementSizing = sizingOf(placementDoc);
    const photoCount = imageCount;
    const altsComplete = photoCount > 0
        && imageAlts.length >= photoCount
        && imageAlts.slice(0, photoCount).every((a) => String(a || '').trim().length > 0);
    const checklist = publishChecklist({
        kind: productKind,
        name: currentName(),
        des: currentDes(),
        category: isAccessory ? '' : styleTypes,
        accessoryType,
        hasImage: imageCount > 0,
        imageCount,
        price: customize ? priceFinal : (price.current ? price.current.value : ''),
        piecesComplete: selectionKeys.length > 0 && selectionKeys.every((k) => presetSelections[k]),
        fabricCount: fabricsIn.length,
        occasions,
        festivals,
        roles,
        vibe,
        colorFamilies,
        longDescription: seoLongDescription,
        faqCount: seoFaqs.filter((f) => f && (f.q || '').trim() && (f.a || '').trim()).length,
        sampleSize,
        stock,
        material: seoMaterial,
        placement: !!placement,
        altsComplete,
    });

    // Drafts only need enough to find them again; publishing needs the full checklist.
    const canSaveDraft = !!currentName().trim() && imageCount > 0 && (!isAccessory || !!accessoryType);
    const isFormValid = seoStatus === 'published' ? checklist.blockers.length === 0 : canSaveDraft;

    const handleSubmit = (e) => {
        e.preventDefault();
        setPublishAttempted(true);
        if (isFormValid) {
            setErr(false);
            uploadPreset();
        } else {
            setErr(true);
        }
    };

    let sectionCounter = 0;
    const nextIdx = () => String(++sectionCounter).padStart(2, '0');

    return (
        <div className="button_upload_page button-upload-premium-page upload-product-page">
            {stylemodal && (
                <div className="opac_bg" onClick={() => setStyleModal(false)}></div>
            )}
            {stylemodal && (
            <StyleModal
                    useFilter={useFilter}
                    type={types}
                    sel={sel}
                setSel={setSel}
            />
            )}

            <div className="upload-product-center">
            <div className="button_upload_form fabric-modern button-upload-premium-form upload-product-form">
                <form onSubmit={handleSubmit} className="button-upload-premium-fields upload-product-fields">

                    <div className="upload-product-mode-hero">
                        {editingDocId && (
                            <div className="upload-product-edit-banner">
                                <span className="upload-product-edit-badge">Editing</span>
                                <span className="upload-product-edit-banner-message">
                                    Updating an existing listing — save to apply changes.
                                </span>
                                <button type="button" className="upload-product-edit-cancel" onClick={handleCancelEdit}>
                                    Cancel edit
                                </button>
                            </div>
                        )}
                        <div className="upload-product-mode-hero-head">
                            <h2>{PRODUCT_KINDS.find((k) => k.value === productKind).title}</h2>
                            <p>{PRODUCT_KINDS.find((k) => k.value === productKind).blurb}</p>
                        </div>
                        <div className="fabric-type-toggle upload-product-mode-toggle upload-product-kind-toggle" role="tablist">
                            {PRODUCT_KINDS.map((k) => (
                                <label
                                    key={k.value}
                                    className={`fabric-type-option ${productKind === k.value ? 'fabric-type-option-active' : ''}`}
                                    role="tab"
                                    aria-selected={productKind === k.value}
                                    title={editingDocId && productKind !== k.value ? 'Product type is fixed while editing' : undefined}
                                >
                                    <input
                                        type="radio"
                                        name="upload-product-mode"
                                        checked={productKind === k.value}
                                        disabled={!!editingDocId && productKind !== k.value}
                                        onChange={() => switchKind(k.value)}
                                    />
                                    <span className="upload-product-mode-icon" aria-hidden="true">{k.icon}</span>
                                    {k.label}
                                </label>
                            ))}
                        </div>
                    </div>

                    <div className="upload-product-section">
                        <div className="upload-product-section-head">
                            <span className="upload-product-section-idx">{nextIdx()}</span>
                            <div>
                                <h3>{isAccessory ? 'Accessory type' : 'Category'} <span className="text-red-500">*</span></h3>
                                <small>
                                    {isAccessory
                                        ? 'Decides where the accessory is listed and searched'
                                        : customize
                                            ? 'Set automatically when you import a customizer link; only garments with a live customizer are available'
                                            : 'Decides the product page, measurement form and default pieces'}
                                </small>
                            </div>
                        </div>
                        <div className="catalog-picker catalog-picker--grouped" role="radiogroup">
                            {isAccessory
                                ? accessoryGroups.map((g) => (
                                    <div className="catalog-picker-group" key={g.label}>
                                        <div className="catalog-picker-group-label">{g.label}</div>
                                        <div className="catalog-picker-group-items">
                                            {g.types.map((a) => (
                                                <button
                                                    type="button"
                                                    key={a.value}
                                                    role="radio"
                                                    aria-checked={accessoryType === a.value}
                                                    className={`catalog-picker-option ${accessoryType === a.value ? 'is-on' : ''}`}
                                                    onClick={() => setAccessoryType(a.value)}
                                                >
                                                    <strong>{a.label}</strong>
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                ))
                                : garmentGroups.map((g) => (
                                    <div className="catalog-picker-group" key={g.label}>
                                        <div className="catalog-picker-group-label">{g.label}</div>
                                        <div className="catalog-picker-group-items">
                                            {g.categories.map((c) => {
                                                const disabled = customize && !c.customizer;
                                                return (
                                                    <button
                                                        type="button"
                                                        key={c.value}
                                                        role="radio"
                                                        aria-checked={styleTypes === c.value}
                                                        disabled={disabled}
                                                        className={`catalog-picker-option ${styleTypes === c.value ? 'is-on' : ''} ${disabled ? 'is-disabled' : ''}`}
                                                        onClick={() => chooseCategory(c.value)}
                                                    >
                                                        <strong>{c.label}</strong>
                                                        <small>{c.pieces.slice(0, 3).join(' · ')}</small>
                                                    </button>
                                                );
                                            })}
                                        </div>
                                    </div>
                                ))}
                        </div>
                        <div className={`catalog-placement ${placement ? '' : 'is-missing'}`}>
                            {placement ? (
                                <>
                                    <span className="catalog-placement-label">Listed on</span>
                                    <strong>{placement.department.label} → {placement.style.label}</strong>
                                    <code>maviinci.in{pathOfStyle(placement.department.slug, placement.style.slug)}</code>
                                    <span className="catalog-placement-sizing">
                                        {placementSizing === 'body' ? 'Garment measurements' : placementSizing === 'head' ? 'Head size' : placementSizing === 'foot' ? 'Foot tracing (A4)' : 'No size needed'}
                                    </span>
                                </>
                            ) : (
                                <span>No website page takes this {isAccessory ? 'accessory type' : 'category'} yet. Pick another, or add it to the catalogue list first.</span>
                            )}
                        </div>
                        {styleTagChoices.length > 0 && (
                            <div className="catalog-styletags">
                                <span className="catalog-placement-label">Also show under</span>
                                {styleTagChoices.map((o) => {
                                    const on = styleTags.includes(o.value);
                                    return (
                                        <button
                                            type="button"
                                            key={o.value}
                                            className={`catalog-styletag ${on ? 'is-on' : ''}`}
                                            aria-pressed={on}
                                            onClick={() => setStyleTags((prev) => (on ? prev.filter((t) => t !== o.value) : [...prev, o.value]))}
                                        >
                                            {o.label}
                                        </button>
                                    );
                                })}
                            </div>
                        )}
                    </div>

                    {productKind === 'sample' && (
                    <div className="upload-product-section">
                        <div className="upload-product-section-head">
                            <span className="upload-product-section-idx">{nextIdx()}</span>
                            <div>
                                <h3>Pieces and fabric</h3>
                                <small>Tick the pieces in this sample, then assign the exact fabric used for each</small>
                            </div>
                        </div>

                        {productKind === 'sample' && (
                            <>
                                <div className="preset-items-label-row">
                                    <div className="preset-items-label">Items included <span className="text-red-500">*</span></div>
                                    <button
                                        type="button"
                                        className="fabric-add-option-btn"
                                        onClick={() => setAddItemModal({ open: true, value: '' })}
                                        aria-label="Add custom item"
                                    >
                                        +
                                    </button>
                                </div>
                                {presetItems.length === 0 ? (
                                    <div className="upload-product-empty-hint">No items yet — click + to add a custom item.</div>
                                ) : (
                                    <>
                                        <div className="fabric-composition-grid preset-items-composition-grid">
                                            {presetItems.map((item) => {
                                                const isTicked = item in presetSelections;
                                                return (
                                                    <div
                                                        key={item}
                                                        className={`fabric-composition-row ${isTicked ? 'fabric-composition-row-active' : ''}`}
                                                    >
                                                        <label className="fabric-composition-checkbox">
                                                            <input
                                                                type="checkbox"
                                                                checked={isTicked}
                                                                onChange={() => toggleItemTick(item)}
                                                            />
                                                            <span className="fabric-composition-tick" aria-hidden="true">
                                                                <svg width="12" height="12" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                                                                    <polyline points="4 10 8 14 16 6"></polyline>
                                                                </svg>
                                                            </span>
                                                            <span className="fabric-composition-name">{item}</span>
                                                        </label>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </>
                                )}

                                {Object.keys(presetSelections).length > 0 && (
                                    <div className="preset-fabric-assign">
                                        <div className="preset-fabric-assign-head">
                                            <strong>Assign Fabrics</strong>
                                            <span>
                                                {Object.values(presetSelections).filter((f) => f).length}
                                                {' / '}
                                                {Object.keys(presetSelections).length} chosen
                                            </span>
                                        </div>
                                        <div className="preset-fabric-assign-list">
                                            {Object.keys(presetSelections).map((item) => {
                                                const pickedFabric = presetSelections[item];
                                                return (
                                                    <div className="preset-fabric-assign-row" key={item}>
                                                        <div className="preset-fabric-assign-label">{item}</div>
                                                        <div className="preset-fabric-assign-slot">
                                                            {pickedFabric ? (
                                                                <div className="preset-item-fabric-card">
                                                                    <div className="preset-item-fabric-thumb">
                                                                        {pickedFabric.src ? (
                                                                            <img src={pickedFabric.src} alt={pickedFabric.name || 'Fabric'} />
                                                                        ) : (
                                                                            <div className="recom-button-card-image-fallback">No preview</div>
                                                                        )}
                                                                    </div>
                                                                    <div className="preset-item-fabric-copy">
                                                                        <strong>{pickedFabric.name || 'Untitled'}</strong>
                                                                        <span>
                                                                            {pickedFabric.brand ? pickedFabric.brand : ''}
                                                                            {pickedFabric.brand && (pickedFabric.color || pickedFabric.pattern) ? ' · ' : ''}
                                                                            {pickedFabric.color || pickedFabric.pattern || ''}
                                                                        </span>
                                                                    </div>
                                                                    <div className="preset-item-fabric-actions">
                                                                        <button type="button" className="preset-item-fabric-change" onClick={() => openFabricPickerFor(item)}>
                                                                            Change
                                                                        </button>
                                                                        <button type="button" className="preset-item-fabric-clear" onClick={() => clearFabricForItem(item)}>
                                                                            Remove
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <button
                                                                    type="button"
                                                                    className="preset-item-select-fabric-btn"
                                                                    onClick={() => openFabricPickerFor(item)}
                                                                >
                                                                    <span>Select Fabric</span>
                                                                    <span className="preset-item-select-fabric-arrow">›</span>
                                                                </button>
                                                            )}
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                    )}

                    {customize && (
                        <div className="upload-product-import">
                            <div className="upload-product-import-head">
        <div>
                                    <h3>Import from URL</h3>
                                    <small>Paste a customize link — items, fabrics and price will auto-fill. You just add name, description, attributes and images.</small>
        </div>
        </div>
                            <div className="upload-product-import-row">
                                <input
                                    type="text"
                                    className="upload-product-import-input"
                                    placeholder="https://maviinci.in/custom/..."
                                    value={importUrl}
                                    onChange={(e) => setImportUrl(e.target.value)}
                                    disabled={importLoading}
                                />
                                <button
                                    type="button"
                                    className="upload-product-import-btn"
                                    onClick={fetchFromUrl}
                                    disabled={importLoading || !importUrl.trim()}
                                >
                                    {importLoading ? 'Fetching...' : 'Fetch'}
                                </button>
                                {importUrl && !importLoading && (
                                    <button
                                        type="button"
                                        className="upload-product-import-clear"
                                        onClick={() => { setImportUrl(''); setImportStatus(null); setImportedData(null); importedStyleRef.current = false; }}
                                    >
                                        Clear
                                    </button>
                                )}
                            </div>
                            {importStatus && (
                                <div className={`upload-product-import-status is-${importStatus.kind}`}>
                                    {importStatus.text}
                                </div>
                            )}
                            {importedData && (() => {
                                const fabObj = importedData.fabric || importedData.fabrics || {};
                                let items = [];
                                if (Array.isArray(fabObj)) {
                                    items = fabObj.map((f) => ({
                                        type: f.type || '',
                                        name: f.fabric || f.name || '',
                                        brand: f.brand || '',
                                        brandImg: f.brandImg || '',
                                        thumb: f.fabricImg || (Array.isArray(f.src) ? f.src[0] : f.src) || '',
                                        pos: f.pos,
                                    }));
                                } else if (fabObj && typeof fabObj === 'object') {
                                    const types = Array.isArray(importedData.types) && importedData.types.length > 0
                                        ? importedData.types
                                        : Object.keys(fabObj);
                                    items = types.map((t) => {
                                        const f = fabObj[t] || {};
                                        return {
                                            type: t,
                                            name: f.fabric || f.name || '',
                                            brand: f.brand || '',
                                            brandImg: f.brandImg || '',
                                            thumb: f.fabricImg || (Array.isArray(f.src) ? f.src[0] : f.src) || '',
                                            pos: f.pos,
                                        };
                                    });
                                }
                                items = items.filter((i) => i.type);
                                items.sort((a, b) => (a.pos || 99) - (b.pos || 99));
                                if (items.length === 0) return null;
                                return (
                                    <div className="upload-product-preview">
                                        <div className="upload-product-preview-summary">
                                            <span className="upload-product-preview-count">{items.length}</span>
                                            <span className="upload-product-preview-count-label">
                                                {items.length === 1 ? 'Item' : 'Items'} to import
                                            </span>
                                        </div>

                                        <div className="upload-product-preview-items">
                                            {items.map((it, i) => (
                                                <div key={i} className="upload-product-preview-item">
                                                    <div className="upload-product-preview-item-thumb">
                                                        {it.thumb ? (
                                                            <img src={it.thumb} alt={it.name || it.type} />
                                                        ) : (
                                                            <div className="upload-product-preview-item-thumb-empty">{(it.type || '?')[0]}</div>
                                                        )}
        </div>
                                                    <div className="upload-product-preview-item-info">
                                                        <span className="upload-product-preview-item-garment">{it.type}</span>
                                                        <span className="upload-product-preview-item-fabric">{it.name || '—'}</span>
                                                    </div>
                                                    <div className="upload-product-preview-item-brand">
                                                        {it.brandImg ? (
                                                            <img src={it.brandImg} alt={it.brand || 'brand'} />
                                                        ) : it.brand ? (
                                                            <span>{it.brand}</span>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                );
                            })()}
                        </div>
                    )}
                    <div className="upload-product-section">
                        <div className="upload-product-section-head">
                            <span className="upload-product-section-idx">{nextIdx()}</span>
                            <div>
                                <h3>Basic details</h3>
                                <small>Name and short description shown on the product card and page</small>
                            </div>
                        </div>

                        <div className="f-inputs">
                            <label className="button-upload-label">Name <span className="text-red-500">*</span></label>
                            <input
                                ref={name}
                                type="text"
                                placeholder={isAccessory ? 'Example: Maroon silk tie with gold paisley' : 'Example: Ivory kurta set with maroon sadri'}
                                onInput={(e) => {
                                    bumpForm();
                                    if (!slugTouched) {
                                        setSeoSlug(slugify(e.target.value));
                                    }
                                }}
                            />
                            <div className="seo-hint">Lead with colour and garment — this is what customers search for.</div>
                        </div>

                        <div className="f-inputs">
                            <label className="button-upload-label">Short description <span className="text-red-500">*</span></label>
                            <textarea ref={des} rows={4} placeholder="Two or three lines: fabric, work, fit and where to wear it." onInput={bumpForm} />
                        </div>
                    </div>

                    <div className="upload-product-section">
                        <div className="upload-product-section-head">
                            <span className="upload-product-section-idx">{nextIdx()}</span>
                            <div>
                                <h3>{isAccessory ? 'Price and stock' : 'Price and delivery'}</h3>
                                <small>
                                    {customize
                                        ? 'Price follows the imported fabrics'
                                        : isAccessory
                                            ? 'Selling price, discount and units in hand'
                                            : 'Price for this design made to the customer\'s measurements'}
                                </small>
                            </div>
                        </div>

                        <div className="upload-product-row">
                            <div className="f-inputs">
                                <label className="button-upload-label">Price (₹) <span className="text-red-500">*</span></label>
                                {!customize ? (
                                    <input ref={price} type="number" min="0" placeholder="0" onInput={bumpForm} />
                                ) : (
                                    <div className="upload-product-price-computed">
                                        <span className="upload-product-price-value">{priceFinal}</span>
                                        <small>Auto-computed from selected fabrics</small>
                                    </div>
                                )}
                            </div>
                            {customize ? (
                                <div className="f-inputs">
                                    <label className="button-upload-label">Discount</label>
                                    <div className="upload-product-price-computed">
                                        <span className="upload-product-price-value">{offer.percent}%</span>
                                        <small>From each fabric's own offer, the same as the customizer charges</small>
                                    </div>
                                    <div className="seo-hint">Customer pays ₹{offer.finalPrice}. Change fabric offers in the fabric list.</div>
                                </div>
                            ) : (
                                <div className="f-inputs">
                                    <label className="button-upload-label">Discount (%)</label>
                                    <input ref={discount} type="number" min="0" max="90" placeholder="Example: 20" onInput={bumpForm} />
                                    <div className="seo-hint">
                                        Customer pays ₹{computeFinalPrice(price.current ? price.current.value : 0, discount.current ? discount.current.value : 0)}
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="upload-product-row">
                            {isAccessory ? (
                                <div className="f-inputs">
                                    <label className="button-upload-label">Stock (units)</label>
                                    <input type="number" min="0" value={stock} onChange={(e) => setStock(e.target.value)} placeholder="Example: 12" />
                                    <div className="seo-hint">Leave blank if you restock on demand. 0 marks it out of stock.</div>
                                </div>
                            ) : (
                                <div className="f-inputs">
                                    <label className="button-upload-label">Sample size</label>
                                    <input
                                        type="text"
                                        value={sampleSize}
                                        onChange={(e) => setSampleSize(e.target.value)}
                                        placeholder="Example: Chest 40, model height 5 ft 10 in"
                                        disabled={customize}
                                    />
                                    <div className="seo-hint">The size stitched for the photos. Orders are always made to the customer's measurements.</div>
                                </div>
                            )}
                            <div className="f-inputs">
                                <label className="button-upload-label">{isAccessory ? 'Dispatch in (days)' : 'Ready in (days)'}</label>
                                <input
                                    type="number"
                                    min="1"
                                    value={deliveryDays}
                                    onChange={(e) => setDeliveryDays(e.target.value)}
                                    placeholder={String(getCategory(styleTypes)?.deliveryDays || 3)}
                                />
                                <div className="seo-hint">Shown as the delivery promise. Blank uses the category default.</div>
                            </div>
                        </div>
                    </div>

                    <div className="upload-product-section">
                        <div className="upload-product-section-head">
                            <span className="upload-product-section-idx">{nextIdx()}</span>
                            <div>
                                <h3>Discovery and filters</h3>
                                <small>These tags decide which searches, occasion pages and filters show this product</small>
                            </div>
                        </div>
                        <DiscoveryPanel
                            kind={productKind}
                            occasions={occasions} setOccasions={setOccasions}
                            festivals={festivals} setFestivals={setFestivals}
                            roles={roles} setRoles={setRoles}
                            vibe={vibe} setVibe={setVibe}
                            formality={formality} setFormality={setFormality}
                            colorFamilies={colorFamilies}
                            colorAuto={colorAuto}
                            setColorFamilies={setColorFamilies}
                            onResetColors={resetColorFamilies}
                            pairsWith={pairsWith} setPairsWith={setPairsWith}
                            pairOptions={pairOptions}
                            suitsCategories={suitsCategories} setSuitsCategories={setSuitsCategories}
                            onSuggest={applySuggestedTags}
                            suggestNote={suggestNote}
                        />
                        {legacyOccasionLabels.length > 0 && (
                            <div className="seo-hint">
                                Kept from the old occasion list: {legacyOccasionLabels.join(', ')}.
                                <button type="button" className="disc-link" style={{ marginLeft: 8 }} onClick={() => setLegacyOccasionLabels([])}>Remove</button>
                            </div>
                        )}
                    </div>

                    <div className="upload-product-section">
                        <div className="upload-product-section-head">
                            <span className="upload-product-section-idx">{nextIdx()}</span>
                            <div>
                                <h3>Care and fit</h3>
                                <small>Shown in the product details tab</small>
                            </div>
                        </div>

                        <div className="upload-product-row">
                            {perPieceCare ? (
                                carePieces.map((t) => (
                                    <div className="f-inputs" key={t}>
                                        <label className="button-upload-label">{t} care</label>
                                        <input
                                            type="text"
                                            list="care-options"
                                            value={careByPiece[t] || ''}
                                            onChange={(e) => setCareByPiece((prev) => ({ ...prev, [t]: e.target.value }))}
                                            placeholder="Pick or type, e.g. Machine wash cold"
                                        />
                                    </div>
                                ))
                            ) : (
                                <div className="f-inputs">
                                    <label className="button-upload-label">Wash care</label>
                                    <input ref={washcare} type="text" list="care-options" placeholder={isAccessory ? 'Example: Spot clean only' : 'Example: Dry clean only'} />
                                </div>
                            )}
                            <datalist id="care-options">
                                {CARE_OPTIONS.map((o) => <option key={o} value={o} />)}
                            </datalist>
                            <div className="f-inputs">
                                <label className="button-upload-label">{isAccessory ? 'Size' : 'Fit'}</label>
                                <input ref={size_fit} type="text" placeholder={isAccessory ? 'Example: Free size, 58 inch length' : 'Example: Tailored fit, relaxed fit'} />
                            </div>
                        </div>
                    </div>

                    <div className="upload-product-section">
                        <div className="upload-product-section-head">
                            <span className="upload-product-section-idx">{nextIdx()}</span>
                            <div>
                                <h3>Photos <span className="text-red-500">*</span></h3>
                                <small>First photo is the thumbnail. Add front, back, side and a close-up of the work — 3 or more convert better.</small>
                            </div>
                        </div>

                        <div className="f-inputs">
                            <div className="fabric-file-title">
                                <b>Upload Files {!editingDocId && <span className="text-red-500">*</span>}</b>
                                {editingDocId && keptImages && keptImages.src && (
                                    <small className="upload-product-edit-images-hint"> Leave empty to keep current images, or choose new files to replace them. </small>
                                )}
                            </div>
                            <input
                                className="fabric-file-input"
                                type="file"
                                multiple
                                accept="image/*"
                                onChange={handleImgsChange}
                            />
                        </div>
                    </div>

                    <div className="upload-product-section">
                        <div className="upload-product-section-head" style={{ cursor: 'pointer' }} onClick={() => setSeoOpen((v) => !v)}>
                            <span className="upload-product-section-idx">{nextIdx()}</span>
                            <div style={{ flex: 1 }}>
                                <h3>SEO and publishing {seoOpen ? '▾' : '▸'}</h3>
                                <small>Status, Google preview, material, colour, FAQs — blanks are filled from the product and its tags</small>
                            </div>
                        </div>
                        {seoOpen && (
                            <SeoPanel
                                ctx={seoContext()}
                                name={currentName()}
                                category={isAccessory ? ACCESSORY_CATEGORY : styleTypes}
                                skuSeed={isAccessory ? accessoryType : styleTypes}
                                docId={editingDocId}
                                slug={seoSlug} setSlug={setSlugManual}
                                sku={seoSku} setSku={setSeoSku}
                                subCategory={seoSubCategory} setSubCategory={setSeoSubCategory}
                                metaTitle={seoMetaTitle} setMetaTitle={setSeoMetaTitle}
                                metaDescription={seoMetaDescription} setMetaDescription={setSeoMetaDescription}
                                keywords={seoKeywords} setKeywords={setSeoKeywords}
                                canonicalUrl={seoCanonicalUrl} setCanonicalUrl={setSeoCanonicalUrl}
                                noindex={seoNoindex} setNoindex={setSeoNoindex}
                                ogImage={seoOgImage} setOgImage={setSeoOgImage}
                                longDescription={seoLongDescription} setLongDescription={setSeoLongDescription}
                                faqs={seoFaqs} setFaqs={setSeoFaqs}
                                material={seoMaterial} setMaterial={setSeoMaterial}
                                pattern={seoPattern} setPattern={setSeoPattern}
                                colorName={seoColorName} setColorName={setSeoColorName}
                                colors={seoColors} setColors={setSeoColors}
                                gender={seoGender} setGender={setSeoGender}
                                availability={seoAvailability} setAvailability={setSeoAvailability}
                                status={seoStatus} setStatus={setSeoStatus}
                                redirectSlugs={seoRedirectSlugs} setRedirectSlugs={setSeoRedirectSlugs}
                                videoUrl={seoVideoUrl} setVideoUrl={setSeoVideoUrl}
                            />
                        )}
                    </div>

                    <div className="publish-check">
                        <div className="publish-check-head">
                            <strong>
                                {seoStatus === 'published' ? 'Ready to publish?' : `Saving as ${seoStatus}`}
                            </strong>
                            <span className={`publish-check-score ${checklist.score >= 80 ? 'is-good' : checklist.score >= 50 ? 'is-mid' : 'is-low'}`}>
                                Listing quality {checklist.score}%
                            </span>
                        </div>
                        {checklist.blockers.length > 0 && (
                            <>
                                <span className="publish-check-label">
                                    {seoStatus === 'published' ? 'Needed before it can go live' : 'Needed before publishing later'}
                                </span>
                                <ul className="publish-check-blockers">
                                    {checklist.blockers.map((b) => <li key={b}>{b}</li>)}
                                </ul>
                            </>
                        )}
                        {checklist.warnings.length > 0 && (
                            <>
                                <span className="publish-check-label">Improves search and SEO</span>
                                <ul className="publish-check-warnings">
                                    {checklist.warnings.map((w) => <li key={w}>{w}</li>)}
                                </ul>
                            </>
                        )}
                        {checklist.blockers.length === 0 && checklist.warnings.length === 0 && (
                            <span className="publish-check-ok">Everything is filled in. This listing is complete.</span>
                        )}
                        {seoStatus === 'published' && checklist.blockers.length > 0 && canSaveDraft && (
                            <div className="seo-hint">
                                Not finished yet?
                                <button type="button" className="disc-link" style={{ marginLeft: 6 }} onClick={() => setSeoStatus('draft')}>
                                    Save as draft instead
                                </button>
                                {' '}— drafts are left out of site search until published.
                            </div>
                        )}
                    </div>

                    {Err && publishAttempted && (
                        <div className="upload-product-error">
                            {seoStatus === 'published'
                                ? 'Complete the items marked in red above, or save as a draft.'
                                : 'A draft needs at least a name and one photo.'}
                        </div>
                    )}

                    {load ? (
                        <div className="outfit-upload-progress">
                            <div className="outfit-upload-progress-top">
                                <span>{uploadStatus || 'Uploading...'}</span>
                                <strong>Working</strong>
                            </div>
                            <div className="outfit-upload-progress-track">
                                <div className="outfit-upload-progress-fill upload-product-progress-indeterminate" />
                            </div>
                        </div>
                    ) : (
                        <button
                            type="submit"
                            className={`fabric-submit-btn upload-product-submit ${!isFormValid ? 'is-disabled' : ''}`}
                            disabled={!isFormValid}
                        >
                            {editingDocId
                                ? (seoStatus === 'published' ? 'Save and publish' : 'Save changes')
                                : (seoStatus === 'published' ? `Publish ${isAccessory ? 'accessory' : 'product'}` : 'Save draft')}
                        </button>
                    )}

                    {preview && preview.length > 0 && (imgs.length > 0 || (editingDocId && keptImages && keptImages.src)) && (
                        <div className="upload-product-ranks">
                            <div className="upload-product-ranks-head">
                                <div>
                                    <h4>Image order</h4>
                                    <small>
                                        Drag and drop to change rank — the first image is the main thumbnail.
                                    </small>
                                </div>
                                <span className="upload-product-ranks-count">{preview.length} image{preview.length === 1 ? '' : 's'}</span>
                            </div>
                            <div className="upload-product-ranks-grid">
                                {preview.map((val, i) => (
                                    <div
                                        key={`${val}-${i}`}
                                        className={`upload-product-rank-card ${i === 0 ? 'is-main' : ''} ${dragIdx === i ? 'is-dragging' : ''} ${dragOverIdx === i && dragIdx !== null && dragIdx !== i ? 'is-drop-target' : ''}`}
                                        draggable={preview.length > 1}
                                        onDragStart={(ev) => preview.length > 1 && handleDragStart(i, ev)}
                                        onDragOver={(ev) => handleDragOver(i, ev)}
                                        onDragLeave={() => handleDragLeave(i)}
                                        onDrop={(ev) => handleDrop(i, ev)}
                                        onDragEnd={handleDragEnd}
                                    >
                                        <img src={val} alt={`Preview ${i + 1}`} draggable={false} />
                                        <span className="upload-product-rank-badge">{i + 1}</span>
                                        {i === 0 && <span className="upload-product-rank-main">Main</span>}
                                        <span className="upload-product-rank-handle" aria-hidden="true">⋮⋮</span>
                            <button
                                            type="button"
                                            className="upload-product-rank-remove"
                                            onClick={(ev) => { ev.stopPropagation(); removeImageAt(i); }}
                                            aria-label="Remove image"
                                        >
                                            ×
                                        </button>
                                        <input
                                            type="text"
                                            className={`upload-product-rank-alt ${!(imageAlts[i] || '').trim() ? 'is-empty' : ''}`}
                                            value={imageAlts[i] || ''}
                                            onChange={(ev) => updateImageAlt(i, ev.target.value)}
                                            onMouseDown={(ev) => ev.stopPropagation()}
                                            placeholder={autoAltText({
                                                colorName: seoColorName,
                                                name: name.current ? name.current.value : '',
                                                view: i === 0 ? 'front view' : `view ${i + 1}`,
                                            }) || 'Alt text (for SEO)'}
                                            draggable={false}
                                        />
                        </div>
                                ))}
                    </div>
                </div>
                    )}
                </form>
            </div>
            </div>

            {addItemModal.open && (
                <div
                    className="fabric-option-modal-backdrop"
                    onClick={() => setAddItemModal({ open: false, value: '' })}
                >
                    <div className="fabric-option-modal" onClick={(ev) => ev.stopPropagation()}>
                        <div className="fabric-option-modal-title">Add custom item</div>
                        <input
                            className="fabric-option-modal-input"
                            autoFocus
                            value={addItemModal.value}
                            onChange={(e) => setAddItemModal((prev) => ({ ...prev, value: e.target.value }))}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    if (addCustomItem(addItemModal.value)) {
                                        setAddItemModal({ open: false, value: '' });
                                    }
                                }
                            }}
                            placeholder="Example: Tie, Waistcoat, Scarf..."
                        />
                        <div className="fabric-option-modal-actions">
        <button
                                type="button"
                                className="fabric-option-modal-cancel"
                                onClick={() => setAddItemModal({ open: false, value: '' })}
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="fabric-option-modal-save"
                                onClick={() => {
                                    if (addCustomItem(addItemModal.value)) {
                                        setAddItemModal({ open: false, value: '' });
                                    }
                                }}
                            >
                                Add
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {pickerModal.open && (
                <div className="recom-modal-backdrop" onClick={closeFabricPicker}>
                    <div className="recom-modal button-fabric-picker-modal" onClick={(ev) => ev.stopPropagation()}>
                        <div className="recom-modal-header">
                            <div>
                                <h3>Select Fabric</h3>
                                <p>Pick a fabric for <strong>{pickerModal.item}</strong>. {filteredFabricsForPicker.length} fabric{filteredFabricsForPicker.length === 1 ? '' : 's'} available.</p>
                            </div>
                            <button type="button" className="recom-modal-close" onClick={closeFabricPicker} aria-label="Close">×</button>
                        </div>

                        <div className="recom-modal-filterbar">
                            <div className="button-fabric-picker-filters">
                                <div className="button-fabric-picker-filter" ref={pickerBrandRef}>
                                    <div className="fabric-custom-select">
                                        <button type="button" className="fabric-custom-select-trigger edit-fabric-select-trigger" onClick={() => setPickerBrandOpen((v) => !v)}>
                                            <span>{pickerBrandFilter || 'All Brands'}</span>
                                            <span className={`fabric-custom-select-arrow ${pickerBrandOpen ? 'open' : ''}`}>▾</span>
                                        </button>
                                        {pickerBrandOpen && (
                                            <div className="fabric-custom-select-menu">
                                                <button type="button" className={`fabric-custom-select-option ${pickerBrandFilter === '' ? 'active' : ''}`} onClick={() => { setPickerBrandFilter(''); setPickerBrandOpen(false); }}>All Brands</button>
                                                {pickerBrandsList.map((val) => (
                                                    <button type="button" key={val} className={`fabric-custom-select-option ${pickerBrandFilter === val ? 'active' : ''}`} onClick={() => { setPickerBrandFilter(val); setPickerBrandOpen(false); }}>{val}</button>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="button-fabric-picker-filter" ref={pickerTypeRef}>
                                    <div className="fabric-custom-select">
                                        <button type="button" className="fabric-custom-select-trigger edit-fabric-select-trigger" onClick={() => setPickerTypeOpen((v) => !v)}>
                                            <span>{pickerTypeFilter || 'All Types'}</span>
                                            <span className={`fabric-custom-select-arrow ${pickerTypeOpen ? 'open' : ''}`}>▾</span>
                                        </button>
                                        {pickerTypeOpen && (
                                            <div className="fabric-custom-select-menu">
                                                <button type="button" className={`fabric-custom-select-option ${pickerTypeFilter === '' ? 'active' : ''}`} onClick={() => { setPickerTypeFilter(''); setPickerTypeOpen(false); }}>All Types</button>
                                                {pickerTypesList.map((val) => (
                                                    <button type="button" key={val} className={`fabric-custom-select-option ${pickerTypeFilter === val ? 'active' : ''}`} onClick={() => { setPickerTypeFilter(val); setPickerTypeOpen(false); }}>{val}</button>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="recom-modal-search">
                                <input
                                    type="text"
                                    placeholder="Search fabric by name, brand, color..."
                                    value={pickerSearch}
                                    onChange={(ev) => setPickerSearch(ev.target.value)}
                                />
                                <img src={sh} alt="Search" />
                            </div>
                        </div>

                        <div className="recom-modal-body">
                            {filteredFabricsForPicker.length === 0 ? (
                                <div className="recom-modal-empty">
                                    No fabrics found{pickerBrandFilter ? ` for brand ${pickerBrandFilter}` : ''}{pickerTypeFilter ? ` of type ${pickerTypeFilter}` : ''}{pickerSearch ? ` matching "${pickerSearch}"` : ''}.
                                </div>
                            ) : (
                                <div className="button-fabric-picker-grid">
                                    {filteredFabricsForPicker.map((f) => {
                                        const isSelected = presetSelections[pickerModal.item] && presetSelections[pickerModal.item].id === f.id;
                                        return (
                                            <div
                                                key={f.id}
                                                className={`outfit-fabric-card ${isSelected ? 'outfit-fabric-card-active' : ''}`}
                                                onClick={() => pickFabricForItem(f)}
                                            >
                                                <img src={f.src} alt={f.name} className="outfit-fabric-card-image" />
                                                <div className="outfit-fabric-card-info">
                                                    <h5>{f.name}</h5>
                                                    <p>{f.brand || '-'}</p>
                                                    <span>{f.color || '-'}{f.width ? ` · ${f.width}` : ''}</span>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {successModal && (
                <div className="outfit-success-modal-backdrop">
                    <div className="outfit-success-modal">
                        <div className="outfit-success-modal-badge">{successModal.edited ? 'Saved' : 'Uploaded'}</div>
                        <h3>
                            {successModal.status === 'published'
                                ? (successModal.edited ? 'Changes are live' : 'Product is live')
                                : `Saved as ${successModal.status}`}
                        </h3>
                        {successModal.thumb && (
                            <div className="upload-product-success-thumb">
                                <img src={successModal.thumb} alt={successModal.name} />
                            </div>
                        )}
                        <div className="outfit-success-modal-grid">
                            <div><span>Name</span><strong>{successModal.name}</strong></div>
                            <div><span>Type</span><strong>{successModal.kind}</strong></div>
                            <div><span>Category</span><strong>{successModal.category}</strong></div>
                            <div><span>Selling price</span><strong>₹{successModal.price}</strong></div>
                            {successModal.count !== null && (
                                <div><span>Fabrics</span><strong>{successModal.count}</strong></div>
                            )}
                        </div>
                        <button type="button" className="fabric-submit-btn outfit-success-close" onClick={() => setSuccessModal(null)}>
                            Close
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Presets_upload;
